import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../img/2solve.svg";
import LogoCurta from "../../img/2s.svg";
import "./sidebar-stylesheet.css";
import { Link } from "react-router-dom";
import ModalExport from "../../components/modalExport";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import IconToSolve from "../../components/icon";

function Sidebar({ toggleSidebar, sidebarOpen }) {
  const { t } = useTranslation();

  // Novo estado para controlar qual menu está aberto
  const [openMenu, setOpenMenu] = useState(null);
  const [showModalExport, setShowModalExport] = useState(false);
  const location = useLocation();
  const [submenuPosition, setSubmenuPosition] = useState({ top: 0 });
  // Novo estado para saber se o menu foi aberto por clique
  const [menuLocked, setMenuLocked] = useState(false);
  const menuContainerRef = useRef(null);

  // Abrir menu (hover ou click)
  const handleMenuOpen = (menu, isClick = false) => {
    setOpenMenu(menu);
    if (isClick) {
      setMenuLocked(true);
    }
    let btn = menuRefs.current[menu];
    if (!btn && !sidebarOpen) {
      btn = menuRefs.current[menu + "-collapsed"];
    }
    if (btn) {
      const rect = btn.getBoundingClientRect();
      if (btn.offsetParent) {
        const sidebarRect = btn.offsetParent.getBoundingClientRect();
        setSubmenuPosition({ top: rect.top - sidebarRect.top });
      } else {
        setSubmenuPosition({ top: 0 });
      }
    }
  };

  // Fechar menu (somente se não estiver bloqueado por clique)
  const handleMenuClose = () => {
    if (!menuLocked) {
      setOpenMenu(null);
    }
  };

  // Fechar quando clicar fora (se bloqueado)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuLocked &&
        menuContainerRef.current &&
        !menuContainerRef.current.contains(event.target)
      ) {
        setOpenMenu(null);
        setMenuLocked(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuLocked]);

  const menuRefs = useRef({});

  useEffect(() => {
    const handleWindowResize = () => {
      if (window.innerWidth < 768) {
        toggleSidebar(false);
      }
    };

    window.addEventListener("resize", handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  }, [toggleSidebar]);

  const isActive = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  const handleLinkClick = () => {
    if (window.innerWidth < 768 && sidebarOpen) {
      toggleSidebar(false);
    }
    setOpenMenu(null); // Fecha o menu ao navegar
  };

  // Definição dos menus principais e seus filhos
  const menus = [
    {
      key: "dashboard",
      label: t("Dashboard"),
      icon: "Home",
      children: [
        {
          to: "/",
          icon: "Home",
          label: t("Home"),
        },
        {
          to: "/alarmes/dashboard/temporeal",
          icon: "Sirene",
          label: t("Alarmes"),
        },
        // {
        //   to: "/forecast",
        //   icon: "Grafico1",
        //   label: t("Forecast"),
        // },
      ],
    },
    // {
    //   key: "manutencao",
    //   label: t("Manutenção"),
    //   icon: "Manutencao",
    //   children: [
    //     {
    //       to: "/servicos",
    //       icon: "Manutencao",
    //       label: t("Serviços"),
    //     },
    //     {
    //       to: "/alarmesComponente",
    //       icon: "Checklist",
    //       label: t("Eventos"),
    //     },
    //   ],
    // },
    {
      key: "cadastro",
      label: t("Cadastro"),
      icon: "Usuario",
      children: [
        {
          to: "/variaveis",
          icon: "Variavel",
          label: t("Variáveis"),
        },
        {
          to: "/ativos",
          icon: "Caminhao",
          label: t("Ativos"),
        },
        {
          to: "/alarmes-cadastro",
          icon: "Alarme",
          label: t("Alarmes"),
        },
        {
          to: "/usuarios",
          icon: "Usuario",
          label: t("Usuários"),
        },
      ],
    },
  ];

  const openModalExport = () => {
    setShowModalExport(true);
  };

  const closeModalExport = () => {
    setShowModalExport(false);
  };

  return (
    <>
      {showModalExport && (
        <ModalExport show={showModalExport} onHide={closeModalExport} />
      )}

      <Navbar className={`col-3 sidebar ${sidebarOpen ? "" : "collapsed"}`}>
        <Navbar.Collapse id="sidebar-nav" className="col-3">
          <div className="sidebar-texto">
            {/* Renderização dos botões principais */}
            {menus.map((menu) => (
              <div
                key={menu.key}
                className="sidebar-menu-btn-wrapper w-100"
                onMouseLeave={handleMenuClose}
                style={{ position: "relative" }}
                ref={menuContainerRef}
              >
                <Button
                  ref={(el) => (menuRefs.current[menu.key] = el)}
                  variant="link"
                  className={`sidebar-group sidebar-menu-btn w-100`}
                  onClick={() => handleMenuOpen(menu.key, true)} // clique bloqueia
                  onMouseEnter={() => handleMenuOpen(menu.key, false)} // hover não bloqueia
                  aria-expanded={openMenu === menu.key}
                >
                  <div className="d-flex align-items-center">
                    <IconToSolve iconName={menu.icon} width={28} height={28} />
                    <span className="ms-2">{menu.label}</span>
                  </div>
                </Button>
                {/* Submenu lateral */}
                {openMenu === menu.key && (
                  <div
                    className="sidebar-submenu"
                    style={{
                      position: "absolute",
                      left: "100%",
                      top: submenuPosition.top,
                      zIndex: 10,
                      background: "#fff",
                      minWidth: 180,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      borderRadius: 3,
                      padding: "10px 0",
                    }}
                    onMouseEnter={() => handleMenuOpen(menu.key)}
                    onMouseLeave={handleMenuClose}
                  >
                    {menu.children.map((child, idx) => (
                      <Link
                        key={child.to}
                        to={child.to}
                        className={`rota sidebar-filho px-3 py-2 d-flex align-items-center w-100 h-100 ${
                          isActive(child.to) ? "pagatual" : ""
                        }`}
                        onClick={handleLinkClick}
                        style={{
                          textDecoration: "none",
                          color: "#222",
                          borderBottom:
                            idx === menu.children.length - 1
                              ? "none"
                              : "1px solid #d3d9e0",
                        }}
                      >
                        <span className="ms-2">{child.label}</span>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {/* Botão Exportar no mesmo estilo dos botões principais */}
            <div
              className="sidebar-menu-btn-wrapper"
              style={{ position: "relative" }}
            >
              <Button
                variant="link"
                className={`sidebar-group sidebar-menu-btn `}
                onClick={openModalExport}
                aria-expanded={false}
                style={{ textAlign: "left" }}
              >
                <div className="d-flex align-items-center">
                  <IconToSolve
                    className=""
                    iconName={"Download"}
                    width={28}
                    height={28}
                  />
                  <span className="ms-2">{t("Exportar")}</span>
                </div>
              </Button>
            </div>
          </div>
          <div className="sidebar-filhos-recolhido">
            {/* Mostra apenas os ícones dos menus pais no modo recolhido */}
            {menus.map((menu) => (
              <div
                key={menu.key}
                className="sidebar-menu-btn-wrapper w-100"
                style={{ position: "relative" }}
                onMouseLeave={handleMenuClose}
              >
                <Button
                  ref={(el) => (menuRefs.current[menu.key + "-collapsed"] = el)}
                  variant="link"
                  className={`rota btn-menu-recolhido ${
                    sidebarOpen ? "hide" : ""
                  } `}
                  onClick={() => handleMenuOpen(menu.key)}
                  onMouseEnter={() => handleMenuOpen(menu.key)}
                  aria-expanded={openMenu === menu.key}
                  style={{
                    padding: 0,
                    height: 48,
                    display: sidebarOpen ? "none" : "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 0,
                    width: "100%",
                  }}
                >
                  <IconToSolve iconName={menu.icon} width={35} height={35} />
                </Button>
                {/* Submenu lateral no modo recolhido */}
                {openMenu === menu.key && !sidebarOpen && (
                  <div
                    className="sidebar-submenu"
                    style={{
                      position: "absolute",
                      left: "100%",
                      top: submenuPosition.top,
                      zIndex: 10,
                      background: "#fff",
                      minWidth: 180,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      borderRadius: 3,
                      padding: "10px 0",
                    }}
                    onMouseEnter={() => handleMenuOpen(menu.key)}
                    onMouseLeave={handleMenuClose}
                  >
                    {menu.children.map((child, idx) => (
                      <Link
                        key={child.to}
                        to={child.to}
                        className={`rota sidebar-filho px-3 py-2 d-flex align-items-center w-100 h-100 ${
                          isActive(child.to) ? "pagatual" : ""
                        }`}
                        onClick={handleLinkClick}
                        style={{
                          textDecoration: "none",
                          fontSize: "16px",
                          zIndex: 10,
                          color: "#222",
                          borderBottom:
                            idx === menu.children.length - 1
                              ? "none"
                              : "1px solid #d3d9e0",
                        }}
                      >
                        <span className="ms-2">{child.label}</span>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {/* Botão Exportar no modo recolhido */}
            <OverlayTrigger
              placement="right"
              delay={{ show: 10 }}
              overlay={<Tooltip id="tooltip-exportar">{t("Exportar")}</Tooltip>}
            >
              <Button
                variant="link"
                className={`rota btn-recolhido-export w-100 ${
                  sidebarOpen ? "hide" : "btn-menu-recolhido "
                }`}
                onClick={openModalExport}
                style={{
                  padding: 0,
                  width: 48,
                  height: 48,
                  display: sidebarOpen ? "none" : "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconToSolve
                  className={""}
                  iconName={"Download"}
                  width={35}
                  height={35}
                />
              </Button>
            </OverlayTrigger>
          </div>
          <Button
            title="Fechar sidebar"
            onClick={() => {
              toggleSidebar();
            }}
            className={`toggle-sidebar-button btn-menu-fechado collapsed${
              sidebarOpen ? "hide" : ""
            }`}
          >
            <i
              className={`bi btn-menu-icn ${
                sidebarOpen ? "bi-caret-left" : "bi-caret-right"
              }`}
            ></i>
          </Button>
          <div className="sidebar-filhos sidebar-img">
            <img
              src={sidebarOpen ? Logo : LogoCurta}
              alt={sidebarOpen ? "Logo 2S" : "Logo 2S"}
              className={` ${sidebarOpen ? "sidebar-logo" : "img-sidebar-short"}`}
              width="100%"
              height="100%"
            />
          </div>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
}
Sidebar.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
};

export default Sidebar;
